import React from 'react';
import { CreditCardIcon, HeadsetIcon, ShieldCheckIcon, TruckIcon } from 'lucide-react';
const usps = [{
  icon: TruckIcon,
  title: 'Shipped in 1–2 days',
  text: 'From our Utrecht warehouse'
}, {
  icon: ShieldCheckIcon,
  title: 'Up to 10-year warranty',
  text: 'Official dealer, EU stock'
}, {
  icon: HeadsetIcon,
  title: 'Advice from engineers',
  text: 'Mon–Sat, 8:00–20:00'
}, {
  icon: CreditCardIcon,
  title: 'Pay later with Klarna',
  text: 'Or in 3 interest-free terms'
}];
export function UspStrip() {
  return <section aria-label="Why shop with us" className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-167" data-mp="34nz5cn7d3y30">
      <ul className="grid grid-cols-2 gap-y-5 border-b border-line py-6 lg:grid-cols-4 lg:divide-x lg:divide-line" data-id="element-168" data-mp="3inrtcari807a">
        {usps.map(({
        icon: Icon,
        title,
        text
      }) => <li key={title} className="flex items-start gap-3 lg:justify-center lg:px-4" data-id="element-169" data-mp="xw7y8wqh5agu">
            <Icon className="mt-0.5 h-5 w-5 shrink-0 text-ink" strokeWidth={1.75} aria-hidden="true" data-id="element-170" data-mp="tuwbcyyzj3cc" />
            <div data-id="element-171" data-mp="36ijjbu75eh4n">
              <p className="text-sm font-semibold text-ink" data-id="element-172" data-mp="36j2rij6zxr5h">{title}</p>
              <p className="text-xs text-muted" data-id="element-173" data-mp="3bhcl4pd2ojoz">{text}</p>
            </div>
          </li>)}
      </ul>
    </section>;
}